import { Android, Apple } from "@mui/icons-material";
import { Box, Button, Container, Stack, Typography } from "@mui/material/";


const AppMobilePage = () => {
  // const authStorage = useAtomValue(authStorageAtom);
  // const { user } = authStorage;

  // console.log("user", user);
  return (
    <Container
      maxWidth="sm"
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        minHeight: {
          xs: "calc(100vh - 56px - 56px)",
          md: "calc(100vh - 69px - 56px)"
        },
        position: "relative",
        pb: 3
      }}
    >
      <Stack
        spacing={4}
        bgcolor="background.default"
        p={3}
        alignItems="center"
        width="100%"
        sx={{ borderRadius: 2, boxShadow: 10 }}
      >
        <Typography component="h6" variant="h6">
          Scarica l'app per il tuo dispositivo
        </Typography>
        <Stack direction="row" justifyContent="center" spacing={4} width="100%">
          <Button
            component="a"
            aria-label="Apple"
            variant="contained"
            size="large"
            href="https://apps.apple.com/us/app/mc-intranet/id1644906047"
            startIcon={<Apple />}
          >
            iOs
          </Button>
          <Button
            component="a"
            aria-label="Android"
            variant="contained"
            size="large"
            href="https://dev.mediacross.it/links/intranet/mc-intranet.apk"
            startIcon={<Android />}
          >
            Android
          </Button>
        </Stack>
        <Box>
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            Utenti Android:
          </Typography>
          <Typography variant="caption" gutterBottom>
            Gli utenti dovranno abilitare la possibilità di installare app di
            terze parti.
          </Typography>
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            Utenti iOs:
          </Typography>
          <Typography variant="caption" gutterBottom>
            Va autorizzato lo sviluppatore, per farlo dovete andare, una volta
            installata, su impostazioni/Generali/Gestione dispositivo, entrare
            su Mediacross srl e autorizzare lo sviluppatore.{" "}
            <a
              href="https://support.apple.com/it-it/HT204460"
              target="_blank"
              rel="noreferrer"
            >
              Per instruzioni cliccare qui
            </a>
            .
          </Typography>
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            In caso di malfunzionamento:
          </Typography>
          <Typography variant="caption" gutterBottom>
            provare a chiudere l'app anche da background e riavviarla, infatti a
            volte vengono rilasciati aggiornamenti che si installano solo al
            riavvio dell'app. <br />
            Se il problema persiste creare una issue su{" "}
            <a
              href="https://request.mediacross.it/projects/intranet/issues"
              target="_blank"
              rel="noreferrer"
            >
              redime
            </a>
            .
          </Typography>
        </Box>
      </Stack>
    </Container>
  );
};

export default AppMobilePage;
